import React from 'react'
import { apiCall } from "../helpers/apiCall";
const UpdateUserDetails = () => {
  return (
    <div>
      update user details
    </div>
  )
}

export default UpdateUserDetails
